/*
*###############################################################################
*Module Name                   : CreditNoteDetails.js                             #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Tuesday, March 8th 2022, 1:16:20 pm           #
*Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
import React, { useState, useContext } from "react"
import { Row, Col, Button } from "reactstrap"
import DPTextBoxforCreditNote from "framework/components/DPTextBoxforCreditNote"
import DPAlert from "framework/widgets/DPAlert"
import { Numeric, DecimalValidation } from "framework/validators/TextValidation" // Textbox input validations
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import DPSwitch from "../../framework/components/DPSwitch"
import { getPaymentModeByHedCode, getPaymentModeDetailByDetCode, getReturnPaymentAmount } from "./CreditNoteController"
import ReactPaginate from "react-paginate"
import { Context } from "app-contexts/CommonContexts"


const CreditNoteDetails = ({
  DataRow,
  setDetailTable,
  TotalCalculation,

  blDiasableGrid,
  menuCode,
  DataPayRow,
  RemovePayRow,
  TotalPayCalculation,
  TotalPayValue,
  Type,
  TotalNetAmount,
  TotalPaidAmount,
  TotalDueAmount,
  TotalPaymentAmout,
  OverPay,
  dispSupplier,
  strSupplier,
  advancePayment,
  setRowsPay,
  ProcessDisable,
  isDocProcessed,
  addNew,
  handlePrintCheque
}) => {

  const {
    txnDecimalAmt
  } = useContext(Context);

  const [page, setPage] = useState(1)
  const [postsPerPage] = useState(10)

  const changeRowValueChanges = (value, id, element) => {

    const objectIndex = DataRow.findIndex(obj => obj.id == id);
    const newObject = { ...DataRow[objectIndex], [element]: value };
    setDetailTable(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = newObject;
      return newDataRow;
    });
  };

  const payChangeRowValueChanges = (value, id, element) => {

    const objectIndex = DataPayRow.findIndex(obj => obj.id == id);
    const newObject = { ...DataPayRow[objectIndex], [element]: value };
    setRowsPay(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = newObject;
      return newDataRow;
    });
  };



  function payHandleObjectChange(row, id) {
    const objectIndex = DataPayRow.findIndex(obj => obj.id == id);
    setRowsPay(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = row;
      return newDataRow;
    });
  }


  function RemovePayRow(id) {
    const filterData = DataPayRow.filter((item) => item.id !== id);

    if (filterData.length == 0) {
      filterData.push({
        paycode: "",
        paydesc: "",
        payDetcode: "",
        payDetName: "",
        payAmount: 0,
        accountCode: "",
        expDate: "",
        overpayEnable: false,
        paymodeEnable: false,
        overpayValue: 0,
        isPaymodeDetail: false,
        printCheque: false,
        acPayee: "",
        dateDisable: true,
        payDetDisable: true,
        refType: "",
        refCheck: 0,
        id: 1
      })
    }

    setRowsPay(filterData);

  }


  function RemoveRow(id) {
    const filterData = DataRow.filter((item) => item.id !== id);

    if (filterData.length == 0) {
      filterData.push({
        "type": "",
        "document": "",
        "date": "",
        "reference": "",
        "location": "",
        "locationName": "",
        "netAmount": 0,
        "paidAmount": 0,
        "dueAmount": 0,
        "creditAmount": 0,
        "payment": 0,
        "id": 1,
      })
    }

    setDetailTable(filterData);

    TotalCalculation();

  }

  function AddPayRow() {

    const payDetails = [...DataPayRow]

    const hasEmptyRow = payDetails.find(x => x.paycode === "" || x.paydesc === "");

    if (hasEmptyRow) {
      return false;
    }

    payDetails.push({
      paycode: "",
      paydesc: "",
      payDetcode: "",
      payDetName: "",
      payAmount: 0,
      accountCode: "",
      expDate: "",
      overpayEnable: false,
      paymodeEnable: false,
      overpayValue: 0,
      isPaymodeDetail: false,
      printCheque: false,
      acPayee: "",
      dateDisable: true,
      payDetDisable: true,
      refType: "",
      refCheck: 0,
      id: DataPayRow.length + 1
    })

    const idpayDetails = payDetails.map((item, index) => {
      item.id = index + 1;
      return item
    })

    setRowsPay(idpayDetails)

  }



  const handlePageClick = (event) => {
    setPage(event.selected + 1);
  };


  const indexOfLastPost = page * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = DataRow.slice(indexOfFirstPost, indexOfLastPost)

  return (
    <React.Fragment>
      <Row className="mb-4">
        {advancePayment == false ?
          <Col sm={12} md={12} className="mb-12-sm">
            <table style={{ fontSize: "11px" }} id={"ProductDet"}>

              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th style={{ textAlign: "left" }}>Type</th>
                  <th style={{ textAlign: "left" }}>Document </th>
                  <th style={{ textAlign: "left" }}>Date </th>
                  <th style={{ textAlign: "left" }}>Ref# </th>
                  <th style={{ textAlign: "left" }}>Location </th>
                  <th style={{ textAlign: "left" }}>Location Name </th>
                  <th style={{ textAlign: "right" }}>Net Amount </th>
                  <th style={{ textAlign: "right" }}>Settled Amount </th>
                  <th style={{ textAlign: "right" }}>Due Amount</th>
                  <th style={{ textAlign: "right" }}>Allocated Amt </th>
                </tr>
              </thead>
              <tbody>
                {(currentPosts || []).map((formRow, key) => (
                  <TableRow
                    FormRow={formRow}
                    Key={indexOfFirstPost + key + 1}
                    RemoveRow={RemoveRow}
                    Disabled={blDiasableGrid}
                    TotalCalculation={TotalCalculation}
                    menuCode={menuCode}
                    OverPay={OverPay}
                    changeRowValueChanges={changeRowValueChanges}
                    txnDecimalAmt={txnDecimalAmt}
                    ProcessDisable={ProcessDisable}
                  />
                ))}
              </tbody>

              <tfoot>
                <tr>
                  <th>&nbsp;</th>
                  <th style={{ textAlign: "center" }}>&nbsp;</th>
                  <th>&nbsp;</th>
                  <th style={{ textAlign: "center" }}>&nbsp;</th>
                  <th>&nbsp;</th>
                  <th style={{ textAlign: "center" }}>&nbsp;</th>

                  <th style={{ textAlign: "left" }}>Total</th>
                  <th style={{ textAlign: "right" }}>
                    <DPTextBoxforCreditNote
                      rowClass="mb-12-sm"
                      labelText="Code"
                      textType="text"
                      maxLength="8"
                      textAlign="right"
                      disabled={true}
                      value={DecimalValidation(TotalNetAmount, 0, true, txnDecimalAmt)}
                    ></DPTextBoxforCreditNote>
                  </th>
                  <th style={{ textAlign: "right" }}>
                    <DPTextBoxforCreditNote
                      rowClass="mb-12-sm"
                      labelText="Code"
                      textType="text"
                      maxLength="8"
                      textAlign="right"
                      disabled={true}
                      value={DecimalValidation(TotalPaidAmount, 0, true, txnDecimalAmt)}
                    ></DPTextBoxforCreditNote>
                  </th>

                  <th style={{ textAlign: "right" }}>
                    <DPTextBoxforCreditNote
                      rowClass="mb-12-sm"
                      labelText="Code"
                      textType="text"
                      maxLength="8"
                      textAlign="right"
                      disabled={true}
                      value={DecimalValidation(TotalDueAmount, 0, true, txnDecimalAmt)}
                    ></DPTextBoxforCreditNote>
                  </th>
                  <th style={{ textAlign: "right" }}>
                    <DPTextBoxforCreditNote
                      rowClass="mb-12-sm"
                      labelText="Code"
                      textType="text"
                      maxLength="8"
                      textAlign="right"
                      disabled={true}
                      value={DecimalValidation(TotalPaymentAmout, 0, true, txnDecimalAmt)}
                    ></DPTextBoxforCreditNote>
                  </th>
                  {/* <th style={{ textAlign: "right" }}>
                  <DPTextBoxforCreditNote
                    rowClass="mb-12-sm"
                    labelText="Code"
                    textType="text"
                    maxLength="8"
                    textAlign="right"
                    disabled={true}
                    value={TotalSellingValue}
                  ></DPTextBoxforCreditNote>
                </th> */}
                </tr>
              </tfoot>
            </table>
            {/* </div> */}

          </Col> : null}
      </Row>
      {advancePayment == false ?
        <Row>
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            pageCount={Math.ceil(DataRow.length / 10)}
            pageRangeDisplayed={2}
            onPageChange={handlePageClick}
            forcePage={page - 1}
            renderOnZeroPageCount={null}
            activeClassName={'active'}
            activeLinkClassName={'page-link'}
            containerClassName={'pagination justify-content-end pagination-sm'}
          />
        </Row> : null}
      <Row>

        <Col sm={12} md={12} className="mb-12-sm">
          <table style={{ fontSize: "11px" }} id={"PaymentDet"}>
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th style={{ textAlign: "left" }}>Payment code</th>
                <th>&nbsp;</th>
                <th style={{ textAlign: "left" }}>Payment Description </th>
                <th style={{ textAlign: "left" }}>Detail Code</th>
                <th>&nbsp;</th>
                <th style={{ textAlign: "left" }}>Detail Name</th>
                <th style={{ textAlign: "left" }}>Card/Cheque No</th>
                <th style={{ textAlign: "left" }}>Expiry Date</th>
                <th style={{ textAlign: "right" }}>Amount</th>
                <th style={{ textAlign: "center" }}>Cheque Print</th>
                <th style={{ textAlign: "left" }}>AC Payee</th>
              </tr>
            </thead>
            <tbody>
              {(DataPayRow).map((formRow, key) => (
                <PaymentTableRow
                  FormRow={formRow}
                  Key={key}
                  RemovePayRow={RemovePayRow}
                  Disabled={blDiasableGrid}
                  TotalPayCalculation={TotalPayCalculation}
                  menuCode={menuCode}
                  dispSupplier={dispSupplier}
                  strSupplier={strSupplier}
                  advancePayment={advancePayment}
                  Type={Type}
                  payChangeRowValueChanges={payChangeRowValueChanges}
                  payHandleObjectChange={payHandleObjectChange}
                  txnDecimalAmt={txnDecimalAmt}
                  ProcessDisable={ProcessDisable}
                  isDocProcessed={isDocProcessed}
                  addNew={addNew}
                  handlePrintCheque={handlePrintCheque}
                />
              ))}
            </tbody>
            <tfoot>
              <tr>
                <th style={{ textAlign: "left" }}></th>
                <th style={{ textAlign: "center" }}>&nbsp;</th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
                <th style={{ textAlign: "left" }}>Total</th>
                <th style={{ textAlign: "right" }}>
                  <DPTextBoxforCreditNote
                    rowClass="mb-12-sm"
                    labelText="Code"
                    textType="text"
                    maxLength="8"
                    textAlign="right"
                    disabled={true}
                    value={TotalPayValue.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
                  ></DPTextBoxforCreditNote>
                </th>
              </tr>
            </tfoot>
          </table>

          <Button type="button" onClick={() => {
            AddPayRow()
          }}
            disabled={blDiasableGrid}
            color="success"
            size="sm"
            class="btn btn-success"> <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
          </Button>

        </Col>

        <Col sm={12} md={4} className="mb-12-sm">

        </Col>
      </Row>
    </React.Fragment>
  )
}
export default CreditNoteDetails

const TableRow = ({
  FormRow,
  Key,
  RemoveRow,
  Disabled,
  TotalCalculation,
  menuCode,
  OverPay,
  changeRowValueChanges,
  txnDecimalAmt,
  ProcessDisable
}) => {


  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)


  const [sweetAlert2Show, setsweetAlert2Show] = useState(false)
  const [AlertDescription2, setAlertDescription2] = useState(false)


  return (
    <tr key={FormRow.id}>
      <td>{Key}</td>
      <td style={{ width: "100px" }}>
        <DPTextBoxforCreditNote
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          maxLength="10"
          id={"txtType" + Key}
          value={FormRow.type}
          disabled={true}
          onChange={e => {
            // setType(e.target.value)
          }}
          val1={FormRow.payment}
          val2={FormRow.dueAmount}
        />
      </td>

      <td style={{ width: "130px" }}>
        <DPTextBoxforCreditNote
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          maxLength="8"
          id={"txtDocument" + Key}
          value={FormRow.document}
          disabled={true}
          onChange={e => {
            // setDocument(e.target.value)
          }}
          val1={FormRow.payment}
          val2={FormRow.dueAmount}
        ></DPTextBoxforCreditNote>
      </td>
      <td style={{ width: "130px" }}>
        <DPTextBoxforCreditNote
          rowClass="mb-12-sm"
          labelText="Code"
          textType="date"
          maxLength="8"
          id={"txtDate" + Key}
          value={FormRow.date}
          disabled={true}
          onChange={e => {
            // setDate(e.target.value)
          }}
          val1={FormRow.payment}
          val2={FormRow.dueAmount}
        ></DPTextBoxforCreditNote>
      </td>
      <td style={{ width: "130px" }}>
        <DPTextBoxforCreditNote
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          maxLength="8"
          id={"txtReference" + Key}
          value={FormRow.reference}
          disabled={true}
          onChange={e => {
            // setReference(e.target.value)
          }}
          val1={FormRow.payment}
          val2={FormRow.dueAmount}
        ></DPTextBoxforCreditNote>
      </td>
      <td style={{ width: "100px" }}>
        <DPTextBoxforCreditNote
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          maxLength="8"
          id={"txtLocation" + Key}
          value={FormRow.location}
          disabled={true}
          onChange={e => {
            // setLocation(e.target.value)
          }}
          val1={FormRow.payment}
          val2={FormRow.dueAmount}
        ></DPTextBoxforCreditNote>
      </td>
      <td style={{ width: "220px" }}>
        <DPTextBoxforCreditNote
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          id={"txtLocationName" + Key}
          value={FormRow.locationName}
          disabled={true}
          onChange={e => {
            // setLocationName(e.target.value)
          }}
          val1={FormRow.payment}
          val2={FormRow.dueAmount}
        ></DPTextBoxforCreditNote>
      </td>
      <td style={{ width: "120px", textAlign: "right" }}>
        <DPTextBoxforCreditNote
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          defaultValue="0"
          textAlign="right"
          id={"txtNetAmount" + Key}
          value={parseFloat(FormRow.netAmount).toFixed(txnDecimalAmt)}
          disabled={true}
          onChange={e => {

          }}
          val1={FormRow.payment}
          val2={FormRow.dueAmount}
        ></DPTextBoxforCreditNote>
      </td>
      <td style={{ width: "120px" }}>
        <DPTextBoxforCreditNote
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          textAlign="right"
          id={"txtPaidAmount" + Key}
          value={parseFloat(FormRow.paidAmount).toFixed(txnDecimalAmt)}
          disabled={true}
          onChange={e => {

          }}
          val1={FormRow.payment}
          val2={FormRow.dueAmount}
        ></DPTextBoxforCreditNote>
      </td>
      <td style={{ width: "120px" }}>
        <DPTextBoxforCreditNote
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          textAlign="right"
          id={"txtDueAmount" + Key}
          value={parseFloat(FormRow.dueAmount).toFixed(txnDecimalAmt)}
          disabled={true}
          onChange={e => {

          }}
          val1={FormRow.payment}
          val2={FormRow.dueAmount}
        ></DPTextBoxforCreditNote>
      </td>
      <td style={{ width: "120px" }}>
        <DPTextBoxforCreditNote
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          textAlign="right"
          id={"txtPayment" + Key}
          value={FormRow.payment}
          disabled={ProcessDisable}
          onChange={e => {

            let allocatedAmt = Numeric(e.target, 18, txnDecimalAmt, true)
            changeRowValueChanges(allocatedAmt, FormRow.id, "payment")

          }}
          val1={FormRow.payment}
          val2={FormRow.dueAmount}
          onBlur={e => {

            let val = DecimalValidation(e.target.value, 0, true, txnDecimalAmt)

            if (parseFloat(val) > parseFloat(FormRow.dueAmount)) {
              if (OverPay) {
                // setPayment(parseFloat(e.target.value).toFixed(txnDecimalAmt))

                changeRowValueChanges(parseFloat(val).toFixed(txnDecimalAmt), FormRow.id, "payment")

                setsweetAlert2Show(true)
                setAlertDescription2("This is an Over Payment, Do you want to continue?")
              } else {
                if (parseFloat(val) > parseFloat(FormRow.dueAmount)) {
                  // setPayment(parseFloat(FormRow.dueAmount).toFixed(txnDecimalAmt))
                  changeRowValueChanges(parseFloat(FormRow.dueAmount).toFixed(txnDecimalAmt), FormRow.id, "payment")
                  setsweetAlertShow(true)
                  setAlertDescription("Over Payment is not allowed")
                  setAlertConfirmOption(1)
                } else {
                  changeRowValueChanges(parseFloat(val).toFixed(txnDecimalAmt), FormRow.id, "payment")
                }
              }
            } else {
              if (val == "") {
                changeRowValueChanges(0, FormRow.id, "payment")
              } else {
                changeRowValueChanges(parseFloat(val).toFixed(txnDecimalAmt), FormRow.id, "payment")
              }
            }
            TotalCalculation()
          }}
        ></DPTextBoxforCreditNote>
      </td>


      <td>
        <Button
          outline
          disabled={ProcessDisable}
          color="danger"
          onClick={e => {
            RemoveRow(FormRow.id)
          }}
          size="sm"
        >
          <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
        </Button>
      </td>

      <DPAlert
        confirm_both={sweetAlertShow}
        title={"Invoice !"}
        description={AlertDescription}
        showCancel={false}
        btnColor={"success"}
        cancelColor={"danger"}
        onConfirm={() => {
          setsweetAlertShow(false)
        }}
        btnYes={"OK"}
      />

      <DPAlert
        confirm_both={sweetAlert2Show}
        title={"Invoice !"}
        description={AlertDescription2}
        showCancel={true}
        btnColor={"success"}
        cancelColor={"danger"}
        onConfirm={() => {
          setsweetAlert2Show(false)
        }}
        btnYes={"OK"}
        onCancel={() => {
          setsweetAlert2Show(false)
          // setPayment(parseFloat(FormRow.dueAmount).toFixed(txnDecimalAmt))
          changeRowValueChanges(parseFloat(FormRow.dueAmount).toFixed(txnDecimalAmt), FormRow.id, "payment")
        }}
        btnNo={"Cancel"}
      />

    </tr>
  )
}
//paymeny
const PaymentTableRow = ({
  FormRow,
  Key,
  RemovePayRow,
  Disabled,
  TotalPayCalculation,
  menuCode,
  dispSupplier,
  strSupplier,
  advancePayment,
  Type,
  payChangeRowValueChanges,
  payHandleObjectChange,
  txnDecimalAmt,
  ProcessDisable,
  isDocProcessed,
  addNew,
  handlePrintCheque
}) => {


  var rowObj = {
    paycode: "",
    paydesc: "",
    payDetcode: "",
    payDetName: "",
    payAmount: 0,
    accountCode: "",
    expDate: "",
    overpayEnable: false,
    paymodeEnable: false,
    overpayValue: 0,
    isPaymodeDetail: false,
    printCheque: false,
    acPayee: "",
    dateDisable: true,
    payDetDisable: true,
    id: 1
  }

  const authToken = localStorage.getItem("authToken")
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)


  async function clickPaySearch() {
    tog_xlargeSup()
  }


  function CheckAccountNoLenth(PayDetcode, Accountno) {
    if (Accountno != "") {
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}Invoice/CheckPaymentLength/${PayDetcode}/${Accountno}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${authToken}`
        },
      })
        .then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {

            const newArray = [...responseData.data]
            setAlertDescription("Card No Length not Matching")
            setAlertConfirmOption(4)
            setsweetAlertShow(true)

          } else {
            //setPaycode("")
          }
        })
    } else {
      // setPaycode("")

    }
  }

  async function GetSupplierPayment() {
    const ApiURL = window.Links.ApiURL
    await fetch(`${ApiURL}common/SupOverpayment/${strSupplier}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${authToken}`
      },
    })
      .then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          // setOverPaymentAmount(parseFloat(responseData.data).toFixed(txnDecimalAmt))

          // setPayAmount(parseFloat(responseData.data).toFixed(txnDecimalAmt))

          var newRow = FormRow
          newRow.overpayValue = parseFloat(responseData.data).toFixed(txnDecimalAmt)
          newRow.payAmount = parseFloat(responseData.data).toFixed(txnDecimalAmt)
          newRow.overpayEnable = true
          payHandleObjectChange(newRow, FormRow.id)

          TotalPayCalculation()

        } else {
          setAlertDescription("No Over Payment")
          setAlertConfirmOption(4)
          setsweetAlertShow(true)
        }
      })

  }


  //* Code Validation from repeating*/
  const CodeValidation = (strCode, id, strDetCode, Detid) => {
    var tbl = document.getElementById("PaymentDet")

    if (strCode == 'CHQ' || strCode == 'CRC') {
      return true
    }

    if (tbl != null) {
      let rowCount = tbl.tBodies[0].rows.length
      for (let i = 0; i < rowCount; i++) {
        var txtcode = document.getElementById("txtPaycode" + i)
        var txtPaydetCode = document.getElementById("txtPaydetCode" + i)
        if ("txtPaycode" + i != id && txtcode.value == strCode) {
          if ("txtPaydetCode" + i != Detid && txtPaydetCode.value == strDetCode) {
            return false
          }
        }
      }
    }
    return true
  }

  const ApiURL = window.Links.ApiURL

  const defaultSortedC = [
    {
      dataField: "id",
      order: "asc",
    },
  ]


  const [modal_xlargePay, setmodal_xlargePay] = useState(false)
  const [modal_xlargePayDet, setmodal_xlargePayDet] = useState(false)
  function tog_xlargeSup() {
    setmodal_xlargePay(!modal_xlargePay)
    removeBodyCss()
  }

  function tog_xlargePayDet() {
    setmodal_xlargePayDet(!modal_xlargePayDet)
    removeBodyCss()
  }

  //removebodyCss function
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const GetSelectRowPayment = async (e, row, isSelect, rowIndex) => {

    GetPaymentAndValidate(row.PH_CODE)
    setmodal_xlargePay(false)

  }

  const GetSelectRowDetail = (e, row, isSelect, rowIndex) => {

    getPaymentModeByDetailCodeCheck(row.PD_CODE)
    setmodal_xlargePayDet(false)

  }


  async function GetPaymentAndValidate(code) {
    const responsedata = await getPaymentMode(code)

    if (responsedata.length > 0) {
      if (advancePayment == true && responsedata[0].pH_LINKWITHOVERPAY == 1) {
        setAlertDescription("You can't select this payment method for advance payments")
        setAlertConfirmOption(4)
        setmodal_xlargePay(false)
        setsweetAlertShow(true)
        setRowEmpty()
        return
      }

      if (responsedata[0].pH_LINKWITHOVERPAY == 1) {
        if (strSupplier != "") {
          await GetSupplierPayment()
        } else {
          setAlertDescription("Please Select Supplier")
          setAlertConfirmOption(4)
          setsweetAlertShow(true)
          setmodal_xlargePay(false)
          setRowEmpty()
          return
        }
      }
    }

  }


  async function getPaymentMode(code) {
    var responsedata = await getPaymentModeByHedCode(code, Type)
    if (responsedata.length > 0) {
      var newRow = FormRow
      newRow.paycode = responsedata[0].pH_CODE
      newRow.paydesc = responsedata[0].pH_DESC
      newRow.isPaymodeDetail = responsedata[0].pH_DETAILS == 1 ? true : false
      newRow.paymodeEnable = true
      newRow.payDetDisable = responsedata[0].pH_DETAILS == 1 ? false : true
      newRow.payDetcode = responsedata[0].pH_DETAILS != 1 ? responsedata[0].pH_CODE : ""
      newRow.payDetName = responsedata[0].pH_DETAILS != 1 ? responsedata[0].pH_DESC : ""
      newRow.refType = responsedata[0].pH_REQDATE != "" ? responsedata[0].tP_REFTYPE : ""
      newRow.refCheck = responsedata[0].pH_REQDATE != "" ? 1 : 0
      payHandleObjectChange(newRow, FormRow.id)
    } else {
      setRowEmpty()
    }

    return responsedata
  }


  async function setRowEmpty() {
    var row = rowObj
    row.id = FormRow.id
    payHandleObjectChange(row, FormRow.id)
  }

  async function getPaymentModeByDetailCodeCheck(code) {

    var responsedata = await getPaymentModeDetailByDetCode(code)
    if (responsedata.length > 0) {
      var newRow = FormRow
      newRow.payDetcode = responsedata[0].pD_CODE
      newRow.payDetName = responsedata[0].pD_DESC
      newRow.payDetDisable = true
      newRow.dateDisable = responsedata[0].pD_REQDATE == 1 ? false : true
      payHandleObjectChange(newRow, FormRow.id)
    } else {
      var newRow = FormRow
      newRow.payDetcode = responsedata[0].pD_CODE
      newRow.payDetName = responsedata[0].pD_DESC
      payHandleObjectChange(newRow, FormRow.id)
    }

  }

  async function getRetunPayment(documentNo) {

    const { data, success, msg } = await getReturnPaymentAmount(documentNo, Type, FormRow.paycode, strSupplier)

    if (success) {
      var newRow = FormRow
      newRow.payAmount = parseFloat(data).toFixed(txnDecimalAmt)
      newRow.refCheck = 0
      payHandleObjectChange(newRow, FormRow.id)
    } else {
      var newRow = FormRow
      newRow.payAmount = 0
      payHandleObjectChange(newRow, FormRow.id)

      setAlertDescription(msg)
      setAlertConfirmOption(4)
      setsweetAlertShow(true)

    }

  }


  //* End Code Validation   */
  return (
    <tr key={FormRow.id}>
      <td>{Key + 1}</td>
      <td style={{ width: "110px" }}>
        <DPTextBoxforCreditNote
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          maxLength="10"
          id={"txtPaycode" + Key}
          value={FormRow.paycode}
          disabled={FormRow.paymodeEnable ? true : Disabled}
          onChange={e => {
            // setPaycode(e.target.value)
            payChangeRowValueChanges(e.target.value, FormRow.id, "paycode")
          }}
          onBlur={e => {
            if (CodeValidation(e.target.value, "txtPaycode" + Key, FormRow.payDetcode, "txtPaydetCode" + Key)) {
              GetPaymentAndValidate(e.target.value)
            } else {
              setAlertDescription("Payment Code already used")
              setAlertConfirmOption(4)
              setsweetAlertShow(true)
            }
          }}
        />
      </td>
      <td>
        <Button
          outline
          color="success"
          disabled={FormRow.paymodeEnable ? true : Disabled}
          id={"btnPaySearch" + Key}
          onClick={clickPaySearch}
          size="sm"
        >
          <i className="mdi mdi-search-web" style={{ fontSize: "12px" }}></i>
        </Button>
      </td>
      <td style={{ width: "200px" }}>
        <DPTextBoxforCreditNote
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          maxLength="8"
          id={"txtPaydesc" + Key}
          value={FormRow.paydesc}
          disabled={true}
          onChange={e => {
            // setPaydesc(e.target.value)
            payChangeRowValueChanges(e.target.value, FormRow.id, "paydesc")
          }}
        ></DPTextBoxforCreditNote>
      </td>
      <td style={{ width: "120px" }}>
        <DPTextBoxforCreditNote
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          maxLength="8"
          id={"txtPaydetCode" + Key}
          value={FormRow.payDetcode}
          disabled={FormRow.payDetDisable ? true : Disabled}
          onChange={e => {
            payChangeRowValueChanges(e.target.value, FormRow.id, "payDetcode")
          }}
          onBlur={e => {
            getPaymentModeByDetailCodeCheck(e.target.value)
          }}

        ></DPTextBoxforCreditNote>
      </td>
      <td>
        <Button
          outline
          color="success"
          disabled={FormRow.payDetDisable}
          id={"btnPayDetSearch" + Key}
          onClick={tog_xlargePayDet}
          size="sm"
        >
          <i className="mdi mdi-search-web" style={{ fontSize: "12px" }}></i>
        </Button>
      </td>
      <td style={{ width: "200px" }}>
        <DPTextBoxforCreditNote
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          maxLength="8"
          id={"txtPayDetdesc" + Key}
          value={FormRow.payDetName}
          disabled={true}
          onChange={e => {
            // setPayDetName(e.target.value)
            payChangeRowValueChanges(e.target.value, FormRow.id, "payDetName")
          }}
        ></DPTextBoxforCreditNote>
      </td>
      <td style={{ width: "160px" }}>
        <DPTextBoxforCreditNote
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          maxLength="16"
          id={"txtAccountCode" + Key}
          value={FormRow.accountCode}
          disabled={Disabled ? true : FormRow.isPaymodeDetail ? FormRow.payDetcode == "" ? true : false : FormRow.refType != "" && FormRow.refCheck == 1 ? false : true}
          onChange={e => {
            payChangeRowValueChanges(e.target.value, FormRow.id, "accountCode")
          }}
          onBlur={e => {
            // CheckAccountNoLenth(PayDetcode, e.target.value)
            if (FormRow.refType != "") {
              if (strSupplier != "") {
                if (e.target.value != "") {
                  getRetunPayment(e.target.value)
                }
              } else {
                setAlertDescription("Please Select Supplier")
                setAlertConfirmOption(4)
                setsweetAlertShow(true)
                setRowEmpty()
                return
              }
            }
          }}
        ></DPTextBoxforCreditNote>
      </td>
      <td style={{ width: "160px" }}>
        <DPTextBoxforCreditNote
          rowClass="mb-12-sm"
          labelText="Code"
          textType="date"
          maxLength="10"
          id={"txtExpDate" + Key}
          value={FormRow.expDate}
          disabled={FormRow.dateDisable ? true : Disabled}
          onChange={e => {
            payChangeRowValueChanges(e.target.value, FormRow.id, "expDate")
          }}
        ></DPTextBoxforCreditNote>
      </td>
      <td style={{ width: "145px" }}>
        <DPTextBoxforCreditNote
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          textAlign="right"
          disabled={Disabled ? true : ProcessDisable == false && isDocProcessed == "No" ? false : ProcessDisable ? true : FormRow.isPaymodeDetail ? FormRow.accountCode == "" ? true : false : FormRow.paycode == "" || FormRow.payDetcode == "" ? true : FormRow.refType != "" ? true : false}
          id={"txtPayAmount" + Key}
          value={FormRow.payAmount}
          onChange={e => {
            let valPayAmount = Numeric(e.target, 18, txnDecimalAmt, true)
            if (valPayAmount == "") {
              payChangeRowValueChanges(parseFloat(0).toFixed(txnDecimalAmt), FormRow.id, "payAmount")
            } else {
              payChangeRowValueChanges(valPayAmount, FormRow.id, "payAmount")
            }
          }}
          onBlur={e => {

            if (FormRow.overpayEnable) {
              if (parseFloat(e.target.value) > parseFloat(FormRow.overpayValue)) {
                setAlertDescription("You can't enter amount more than " + FormRow.overpayValue)
                setAlertConfirmOption(4)
                setsweetAlertShow(true)
                payChangeRowValueChanges(parseFloat(FormRow.overpayValue).toFixed(txnDecimalAmt), FormRow.id, "payAmount")
              } else {
                payChangeRowValueChanges(parseFloat(e.target.value).toFixed(txnDecimalAmt), FormRow.id, "payAmount")
              }
            } else {
              payChangeRowValueChanges(parseFloat(e.target.value).toFixed(txnDecimalAmt), FormRow.id, "payAmount")
            }
            TotalPayCalculation()
          }}
        ></DPTextBoxforCreditNote>
      </td>
      <td style={{ width: "100px", textAlign: "center" }}>
        <DPSwitch
          id={"printCheque" + Key}
          checked={FormRow.printCheque}
          disabled={Disabled ? true : FormRow.paycode == 'CHQ' && FormRow.accountCode != '' && parseFloat(FormRow.payAmount) > 0 ? false : true}
          onChange={e => {
            payChangeRowValueChanges(e, FormRow.id, "printCheque")
          }}
        />
      </td>
      <td style={{ width: "160px" }}>
        <DPTextBoxforCreditNote
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          maxLength="10"
          id={"acPayee" + Key}
          value={FormRow.acPayee}
          disabled={Disabled ? true : FormRow.printCheque ? false : true}
          onChange={e => {
            payChangeRowValueChanges(e.target.value, FormRow.id, "acPayee")
          }}
        ></DPTextBoxforCreditNote>
      </td>
      <td>
        <Button
          outline
          disabled={ProcessDisable}
          color="danger"
          onClick={e => {
            RemovePayRow(FormRow.id)
          }}
          size="sm"
        >
          <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
        </Button>
      </td>
      {FormRow.printCheque && !addNew ?
        <td>
          <Button
            outline
            color="primary"
            size="sm"
            onClick={async (e) => {
              await handlePrintCheque(FormRow.paycode, FormRow.payDetcode, FormRow.accountCode)
            }}
          >
            <i className="mdi mdi-printer" style={{ fontSize: "12px" }}></i>
          </Button>
        </td> : null
      }

      <DPSearchBoxDynamic
        searchData={[]}
        columns={[]}
        defaultSorted={defaultSortedC}
        mainTitle={"Payment Search"}
        SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
        isOpen={modal_xlargePay}
        toggle={tog_xlargeSup}
        getSelect={GetSelectRowPayment}
        APIURL={ApiURL}
        URLPath={"PAYM"}
        MenuCode={menuCode}
        KeyVal={"TXN"}
        searchBy={"PH_CODE"}
        FilterStr={` AND T.TP_TXCODE ='${Type}'`}
      />
      <DPSearchBoxDynamic
        searchData={[]}
        columns={[]}
        defaultSorted={defaultSortedC}
        mainTitle={"Payment Detail Search"}
        SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
        isOpen={modal_xlargePayDet}
        toggle={tog_xlargePayDet}
        getSelect={GetSelectRowDetail}
        APIURL={ApiURL}
        URLPath={"PAYDET"}
        MenuCode={menuCode}
        KeyVal={"TXN"}
        searchBy={"PD_CODE"}
        FilterStr={`AND M.PD_PHCODE = '${FormRow.paycode}' `}
      />

      <DPAlert
        confirm_both={sweetAlertShow}
        title={"Invoice !"}
        description={AlertDescription}
        showCancel={false}
        btnColor={"success"}
        cancelColor={"danger"}
        onConfirm={() => {
          setsweetAlertShow(false)
        }}
        btnYes={"OK"}
      />

    </tr>
  )
}